import { Container, Grid, Link } from "@mui/material";
import React, { useState , useEffect } from "react";
import NFTCards from "../../../Components/NFTCards";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import Web3 from "web3";

import DashboardMenuForDesktop from "../../../Components/Menu/DashboardMenu";

import ErroBook from "../../../Components/ErroBook/ntErro"
import Loader from "../../../Components/ErroBook/loader"

import logo from "../../../images/logo.png"
import playtable_half from "../../../images/playtable_half.png"
import swapImg from "../../../images/swap.png"


import snoonerIcon from "./../../../images/snooner-icon.png"
import inGameIcon from "./../../../images/in-game-icon.png"
import playerIcon from "./../../../images/player-icon.png"
import graph from "./../../../images/graph.png"
import TopWinning from "../../../Components/TopWinningCard";
import ConnectScreen from "../Login/connectscreen";

var web3;
var deciConvert = 1e18;
var msAdd;
var msAbi;
var msContract
var swapAdd;
var swapAbi;
var swapContract
let appID = 'cf4363b024a1a9a2991ff2e7571ddcef';
let historyData = [];
let topWiningTable = [];
    
const NFTScreen = () => {
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [useSwapForm, setSwapForm] = useState(false);
    const [useApproveBTN, setApproveBTN] = useState(true);
    const [useMetaAmount, setMetaAmount] = useState('');
    const [useMetaInGameAmount, setMetaInGameAmount] = useState('');
    const [useMetaAmountError, setMetaAmountError] = useState(false);
    const [useInGameAmount, setInGameAmount] = useState('');
    const [useInGameMetaAmount, setInGameMetaAmount] = useState('');
    const [useInGameAmountError, setInGameAmountError] = useState(false);
    const [useInGameRate, setInGameRate] = useState('0');
    
     
    

    // wallet related states
    const [useWalletAddress, setWalletAddress] = useState('0x');
    const [useUserMetaBalance, setUserMetaBalance] = useState('0');
    const [useMetaTokenBalance, setMetaTokenBalance] = useState('0');
    const [useUserInGameBalance, setUserInGameBalance] = useState('0');
    const [useInGameTokenBalance, setInGameTokenBalance] = useState('0');
    const [useError, setError] = useState(false);
    const [useErrorType, setErrorType] = useState('a');
    const [useLoader, setLoader] = useState(false);
    
    const [useWalletConnected, setWalletConnected] = useState(false);

    const handleInputSwap = (event, newFormats) => {
        setInGameAmount('')
        setMetaAmount('')
        setMetaAmountError(false)
        setInGameAmountError(false)
        if (newFormats == '') {
            setSwapForm(false);
        } else {
            setSwapForm(newFormats);
        }
    };


    useEffect(()=> {
            if( localStorage.getItem("token") == "" || localStorage.getItem("token") == null ){
                window.location.replace("/login");
            }
            connectWallet();
            setTimeout(() => {
                setError(false)
            }, 5000)

    },[ useWalletAddress]);
    useEffect(()=> {
            fetch('https://metasnooker.herokuapp.com/api/auth/app_id=' + appID + '/findone/' + localStorage.getItem("userDbAddress"), {
                method: "GET",
                headers: {"Authorization": `Bearer `+ localStorage.getItem("token") }
            }).then(jsonData => {
                jsonData.json().then(data => {
                    historyData = [
                        data.map( ( i, j ) => {
                            return(
                            <TableRow>
                                <TableCell className="text-center" style={{minWidth: 20}} >
                                    {j+1}
                                </TableCell>
                                <TableCell className="text-left" style={{minWidth: 100}} >
                                    {conciseWallet(i.address)}
                                </TableCell>
                                <TableCell className="text-center" style={{minWidth: 50}} >
                                    {i.challengeprice}
                                </TableCell>
                                <TableCell className="text-center" style={{minWidth: 70}} >
                                    {i.result==1 ? <span className="win">Win</span> : <span className="loss">Loss</span>}
                                </TableCell>
                                <TableCell className="text-center" style={{minWidth: 100}} >
                                    {dateformate(i.updatedAt)}
                                </TableCell>
                            </TableRow>
                            )
                        })
                    ]
                })
            });
        },[])
        const dateformate = (val) => {
            var date_old = new Date(val).getTime()
            var date = new Date(date_old)
            return date.toLocaleString('en-US')
        }
        const timeSince = (val) => {
            var date_old = new Date(val).getTime()
            var date_today = Date.now()
            var date = new Date(date_old)
            // var date;
            var seconds = Math.floor((new Date() - date) / 1000);
          
            var interval = seconds / 31536000;
          
            if (interval > 1) {
              return Math.floor(interval) + " years";
            }
            interval = seconds / 2592000;
            if (interval > 1) {
              return Math.floor(interval) + " months";
            }
            interval = seconds / 86400;
            if (interval > 1) {
              return Math.floor(interval) + " days";
            }
            interval = seconds / 3600;
            if (interval > 1) {
              return Math.floor(interval) + " hours";
            }
            interval = seconds / 60;
            if (interval > 1) {
              return Math.floor(interval) + " minutes";
            }
            return Math.floor(seconds) + " seconds";
          }
          var aDay = 24*60*60*1000;
    /***************************************************
    *
    *    Handle web3 integration in DApp
    *    1=> amountFormate 
    *        a) set amount comma 
    *        b) set humber of digit after decimal
    *  
    *    2=> conciseWallet
    *        This function is used to hide half wallet address
    *        (i.e. 0xabc....zyx)
    * 
    *    3=> chainChanged
    *        This is ethereum function from web3, used to handle
    *        in changing NETWORK from metamask 
    * 
    *    4=> accountsChanged
    *        This is ethereum function from web3, used to handle
    *        in changing USER-WALLET-ADDRESS from metamask 
    *    
    *    5=> connectWallet
    *        This function is used to deal with contract(s)
    *        (i.e. getting/sending values from/in the contract(s)
    *        It will call when page reload and also on click
    * 
    *
    ****************************************************/
    // 1=> numaricAmount
    const amountFormate = (num,digit) => {
        var testnumber = Number.parseFloat(num).toFixed(digit);
        return testnumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    // 2=> conciseWallet
    const conciseWallet = (value) => {
        const intvalue = value.toString();
        if( intvalue != ""){
            const start_char = value.toString().substring(0,6)+"*********";
            const end_char = value.toString().substr(value.length - 4);
            return (start_char + end_char)
        }
    }

    // 3=> chainChanged
    window.ethereum.on('connect',  ( _connectInfo => {
        // BSC 0x38
        // BSCTestnet 0x61
        if ( _connectInfo.chainId != "0x38") {
            setErrorType('wrongNetwork')
            setError(true)
        }
    }));
    window.ethereum.on('chainChanged', (_chainId => {
        // BSC 0x38
        // BSCTestnet 0x61
        if ( _chainId == "0x38") {
            window.location.reload();
        }else{
            setLoader(true)
            setErrorType('wrongNetwork')
            setError(true)
        }
    }));

    // 4=> accountsChanged
    try {
        window.ethereum.on('accountsChanged', ( _mAddress => {
            if( _mAddress != "" ){
                setErrorType('walletChanged');
                setError(true);
                window.location.reload();
            }else{
                setWalletConnected(false)
                setErrorType('walletNotConnected')
                setLoader(false)
                setError(true)
            }
        }));
    } catch (error) {
        console.log('Address: ', error)
    }

    // 5=> connectWallet
    const connectWallet = () => {
        if(typeof Web3 !== 'undefined'){

            web3 = new Web3(window.ethereum);
            try {
                window.ethereum.request({ method: 'eth_chainId' }).then( _chainId => {
                    // BSC 0x38
                    // BSCTestnet 0x61
                    if ( _chainId != "0x38") {
                        setLoader(true)
                        setErrorType('wrongNetwork')
                        setError(true)
                    }
                })
            } catch (error) {
                console.log(error)
            }
            //MetaSnooker contract 
            msAdd = "0x758d13F0F33Bfe3FD4dfeBbB5CfE1DFf942bF2c2";
            msAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burnFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]
            msContract = new web3.eth.Contract( msAbi , msAdd );

            //Swap contract 
            swapAdd = "0x5bb9AB2179A80D8E742EAf81fc5F1d584b8e6215";
            swapAbi = [{"inputs":[{"internalType":"address","name":"meta","type":"address"},{"internalType":"address","name":"_tax_distribution","type":"address"},{"internalType":"uint256","name":"_tax_rate","type":"uint256"},{"internalType":"uint256","name":"_conversion_rate","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipPulled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipPushed","type":"event"},{"inputs":[],"name":"conversion_rate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"failsafe","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"ingame_swapped","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"manager","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"meta_swapped","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pullManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner_","type":"address"}],"name":"pushManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_token","type":"address"}],"name":"recoverLostToken","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"identifier","type":"string"}],"name":"register","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"","type":"string"}],"name":"registered_data","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"registered_users","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"removeFailsafe","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_rate","type":"uint256"}],"name":"setConversionRate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"setFailsafe","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_rate","type":"uint256"}],"name":"setTaxRate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"setTaxWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"value","type":"uint256"}],"name":"swapInGame","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"value","type":"uint256"}],"name":"swapMeta","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"tax_rate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"}]
            swapContract = new web3.eth.Contract( swapAbi , swapAdd );

            // CG API call handle to get token price
            // fetch('https://api.coingecko.com/api/v3/coins/cardano').then(jsonData => {
            //     jsonData.json().then(data => {
            //         console.log('Price API' , data)
            //     })
            // });


            
            //get connected wallet address
            try {
                window.ethereum.request({ method: 'eth_requestAccounts'}).then( _account => {
                    conciseWallet(_account.toString());
                    setWalletConnected(true)
                    let userWalletAdd = _account.toString()
                    if ( localStorage.getItem("userDbAddress") != userWalletAdd) {
                        handleLogout()
                    } else {
                        setWalletAddress(userWalletAdd)
                        msContract.methods.allowance(_account.toString(),swapAdd).call().then( result => {
                            if( result > 1 ){
                            setApproveBTN(false)
                            }else{
                            setApproveBTN(true)
                            }   
                            setLoader(false)     
                        }) 
                    }
                })
                .catch (error => {
                    setErrorType('walletNotConnected')
                    setError(true)
                });
            } catch (error) {
                setErrorType('noMetamask')
                setError(true)
            }
        }else{
            console.log('Please install metamask to use this page.!')
        }
    }
    
    const handleApprove = () => {
        // setLoader('block');
        setLoader(true)
        msContract.methods.approve(swapAdd, '115792089237316195423570985008687907853269984665640564039457584007913129639935')
        .send({from: useWalletAddress}).then( test => {
            msContract.methods.allowance(useWalletAddress,swapAdd).call().then( result => {
            if( result > 1 ){
              setApproveBTN(false)
            }else{
              setApproveBTN(true)
            }   
            setLoader(false)     
          })
        })
        .catch(error => {
            setLoader(false)
          console.log('Getting Errors: ' , error);
        });
    }
    


    const handleLogout = () => {
        console.log('User has been logd: ', localStorage.getItem("token") )
        localStorage.clear();
        setError(true)
        console.log('User has been logd: ', localStorage.getItem("token") )
    }


    const userValidate = (val) => {
        return val.substring(0, val.lastIndexOf("@") )
    }
    return(
        <div className="MS---dashboard position-relative">
            {useError ?
                <ErroBook 
                    errorType = {useErrorType}
                />
            :
                <span />
            }
            { useLoader ? 
                <Loader />
                :
                <span />
            }
            { useWalletConnected ?
                <Grid 
                    container
                    justifyContent="flex-start"
                    className="AppDapp Dashboard position-relative p-3"
                >
                    <DashboardMenuForDesktop />
                    <Grid md={2} />
                    <Grid 
                        container
                        xs={12}
                        md={10} 
                        className="MS--mainScreen py-4"
                        alignContent="flex-start"
                        justifyContent="flex-start"
                    >
                        {/* <Bar
                data={{
                    // Name of the variables on x-axies for each bar
                    labels: ["1st bar", "2nd bar", "3rd bar", "4th bar"],
                    datasets: [
                    {
                        // Label for bars
                        label: "total count/value",
                        // Data or value of your each variable
                        data: [1552, 1319, 613, 1400],
                        // Color of each bar
                        backgroundColor: ["aqua", "green", "red", "yellow"],
                        // Border color of each bar
                        borderColor: ["aqua", "green", "red", "yellow"],
                        borderWidth: 0.5,
                    },
                    ],
                }}
                // Height of graph
                height={400}
                options={{
                    maintainAspectRatio: false,
                    scales: {
                    yAxes: [
                        {
                        ticks: {
                            // The y-axis value will start from zero
                            beginAtZero: true,
                        },
                        },
                    ],
                    },
                    legend: {
                    labels: {
                        fontSize: 15,
                    },
                    },
                }}
                /> */}
                        <Grid
                            xs={12}
                            className="text-left pb-5 px-lg-4 pl-md-4"
                        >
                            <h4 className="text-capitalize">
                                Hello, {userValidate(localStorage.getItem("email"))}
                            </h4>
                            <p>Connected: {conciseWallet(localStorage.getItem("userDbAddress"))}</p>
                        </Grid>
                        
                        <NFTCards />
                        <NFTCards />
                        <NFTCards />
                        <NFTCards />
                    </Grid>
                </Grid>
        :
            <ConnectScreen 
                connectFun = {connectWallet}
            />
        }
        </div>
    );
}

export default NFTScreen;